import React from 'react';

import { Box, Typography, styled } from '@mui/material';

import { Icon } from '@liscio/ui';

import { ExportStatus } from '../../types';

const SuccessIcon = styled(Icon)({
  fontSize: '48px',
  marginBottom: 2,
});

const CenteredBox = styled(Box)({
  textAlign: 'center',
});

interface ExportSuccessDetailsProps {
  exportStatus: ExportStatus;
}

export const ExportSuccessDetails = ({ exportStatus }: ExportSuccessDetailsProps) => {
  return (
    <CenteredBox>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <SuccessIcon 
          icon="success" 
          sx={{ color: 'success.main' }} 
        />
        <Typography variant="h6" sx={{ color: 'success.dark', mb: 1, fontWeight: 600 }}>
          Export Successful!
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          You can view your files in your GruntWorx dashboard!
        </Typography>
        
        {exportStatus.export_id && (
          <Box sx={{ bgcolor: 'grey.50', px: 2, py: 1, borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Export ID: {exportStatus.export_id}
            </Typography>
          </Box>
        )}
      </Box>
    </CenteredBox>
  );
}; 